import React, { useEffect, useState } from "react";
import { sendToAndroid } from "../services/androidBridge";
import { ChevronRight } from "lucide-react";
import "./TransferList.css";
import {
  Other,
  transferListLanguageOptions,
} from "../components/dropdown/dropdown-data";
import { BaseUrl } from "../utils/url";
import { menuServices } from "../config/serviceRegistry";

const TransferList = () => {
  const [url, setUrl] = useState("");
  const [title, setTitle] = useState();
  const [jwt, setJwt] = useState(0);

  const [data, setData] = useState([]);

  const [isFirst, setIsFirst] = useState(true);

  const handleFirstRender = (request) => {
    if (!isFirst) {
      sendDataToAndroid(request);
    }
    setIsFirst(false);
  };

  useEffect(() => {
    sendDataToAndroid("first");

    window.receiveDataFromAndroid = (data) => {
      var dataString = JSON.stringify(data);
      var obj = JSON.parse(dataString);

      if (JSON.parse(obj.request).name === "jwt") {
        const jwtValue = JSON.stringify(JSON.parse(obj.response).data);
        setJwt(jwtValue);
      }
    };
  }, []);

  const transferClicked = (value) => {
    setUrl(value);
  };

  useEffect(() => {
    sendDataToAndroid("url");
  }, [url]);

  useEffect(() => {
    handleFirstRender("title");
  }, [title]);

  useEffect(() => {
    const currentLanguage =
      transferListLanguageOptions[jwt] ?? transferListLanguageOptions[0];
    const dataValue = menuServices.map((service) => ({
      id: service.id,
      icon: service.icon,
      name: currentLanguage[service.labelIndex],
      url: `${BaseUrl}${service.path}`,
    }));
    if (!isFirst) {
      setTitle((Other[jwt] ?? Other[0])[0]);
    }
    setIsFirst(false);
    setData(dataValue);
  }, [jwt]);

  const sendDataToAndroid = (name) => {
    var transferData = {
      transferData: [],
    };
    if (name === "return") {
      transferData = {
        transferData: [
          {
            type: "return",
            request: { name: "graphData" },
            response: {},
            name: "",
          },
        ],
      };
    } else if (name === "first") {
      transferData = {
        transferData: [
          {
            type: "first",
            request: { name: "first" },
            response: {},
            name: "",
          },
        ],
      };
    } else if (name === "url") {
      transferData = {
        transferData: [
          {
            type: "url",
            request: { name: "url" },
            response: { data: url },
            name: "",
          },
        ],
      };
    } else if (name === "title") {
      transferData = {
        transferData: [
          {
            type: "title",
            request: { name: "title" },
            response: { data: title },
            name: "",
          },
        ],
      };
    } else if (name === "openLoading") {
      transferData = {
        transferData: [
          {
            type: "openLoading",
            request: { name: "openLoading" },
            response: { data: "openLoading" },
            name: "",
          },
        ],
      };
    } else if (name === "closeLoading") {
      transferData = {
        transferData: [
          {
            type: "closeLoading",
            request: { name: "closeLoading" },
            response: { data: "closeLoading" },
            name: "",
          },
        ],
      };
    } else if (name === "warning") {
      transferData = {
        transferData: [
          {
            type: "warning",
            request: { name: "warning" },
            response: { data: "warning" },
            name: "",
          },
        ],
      };
    } else if (name === "error") {
      transferData = {
        transferData: [
          {
            type: "error",
            request: { name: "error" },
            response: { data: "error" },
            name: "",
          },
        ],
      };
    } else if (name === "title") {
      transferData = {
        transferData: [
          {
            type: "title",
            request: { name: "title" },
            response: { data: title },
            name: "",
          },
        ],
      };
    }

    sendToAndroid(transferData);
    setUrl("");
  };

  return (
    <main className="transfer-list min-h-screen bg-slate-50 px-3 py-4 sm:px-4">
      <div className="mx-auto w-full max-w-lg overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
        <nav
          className="grid grid-cols-2 gap-3 p-4 sm:gap-4 sm:p-6"
          aria-label="Payment services"
        >
          {data.map((item) => {
            const ServiceIcon = item.icon;

            return (
              <button
                type="button"
                key={item.id}
                className="service-card group"
                onClick={() => transferClicked(item.url)}
                aria-label={item.name}
              >
                <span className="service-card-icon">
                  <ServiceIcon size={26} strokeWidth={1.9} aria-hidden="true" />
                </span>
                <span className="service-card-content">
                  <span className="service-card-label">{item.name}</span>
                  <ChevronRight
                    className="service-card-arrow"
                    size={17}
                    aria-hidden="true"
                  />
                </span>
              </button>
            );
          })}
        </nav>
      </div>
    </main>
  );
};

export default TransferList;
